export enum AnalyticsNamespace {
  SIP_CLIENT = 'sipc',
  RECENT_CALLS = 'rc',
  VOICEMAIL = 'vm',
  FAXING = 'fax',
  CONTACTS = 'contacts',
  CALL_ANALYTICS = 'ca',
  WEB_PHONE = 'wp',
  MESSAGING = 'msg',
  AUTHENTICATION = 'auth',
  EXPERIMENTS = 'exprmnts',
  SHARED = 'shared',
  WEB_SOCKET = 'ws',
}
